import { formatExpiresAt } from './formatExpiresAt';
import { isPaymentMethodFailed } from './isPaymentMethodFailed';
const getPaymentMethodProps = (paymentMethod) => {
    const result = [];
    if (paymentMethod.default) {
        result.push({
            label: 'Default',
            appearance: 'neutral',
        });
    }
    if (paymentMethod.status === 'FAILED') {
        result.push({
            label: 'Failed',
            appearance: 'alert',
        });
    }
    return result;
};
export const mapPaymentMethods = (response) => response.result.map((paymentMethod) => {
    if (paymentMethod.details.type === 'CARD') {
        return {
            id: paymentMethod.id,
            type: 'CARD',
            brand: paymentMethod.details.brand,
            number: paymentMethod.details.last4Digits,
            expires: formatExpiresAt(paymentMethod.details.expiresAt),
            expired: paymentMethod.details.expired,
            tagsProps: getPaymentMethodProps(paymentMethod),
            default: paymentMethod.default,
            invalid: isPaymentMethodFailed(paymentMethod),
        };
    }
    // PAYPAL
    return {
        id: paymentMethod.id,
        type: 'PAYPAL',
        email: paymentMethod.details.email,
        tagsProps: getPaymentMethodProps(paymentMethod),
        default: paymentMethod.default,
        invalid: isPaymentMethodFailed(paymentMethod),
    };
});
